import request from './../plugins/axios'

// 人员列表-获取员工列表
function StaffList (data) {
  return request({
    url: '/staff/list',
    method: 'post',
    data
  })
}
// 人员列表-员工详情
function StaffDetails (data) {
  return request({
    url: '/staff/details',
    method: 'post',
    data
  })
}

// 人员列表-待审核入职
function StaffAuditList (data) {
  return request({
    url: '/audit/list',
    method: 'post',
    data
  })
}

// 人员列表-审核员工 -- 暂时不掉
function StaffAuditPasslList (data) {
  return request({
    url: '/audit/pass/list',
    method: 'post',
    data
  })
}

// 人员列表-删除员工
// staff/delete
function StaffDelete (data) {
  return request({
    url: '/staff/delete',
    method: 'post',
    data
  })
}
// 人员列表-编辑员工
function StaffUpdate (data) {
  return request({
    url: '/staff/update',
    method: 'post',
    data
  })
}
// 人员列表-职级调整
// 人员列表-离职
// 人员列表-录入新员工
// 人员列表-批量导入新员工
// 人员列表-审核
// /audit/approved 1 审核 2 驳回
function AuditApproved (data) {
  return request({
    url: '/audit/approved',
    method: 'post',
    data
  })
}
// 人员列表-上传图片
// 人员列表-添加员工
function StaffAdd (data) {
  return request({
    url: '/staff/add',
    method: 'post',
    data
  })
}
// 人员列表 - 身份证验证
function entryAuthentication (data) {
  return request({
    url: '/entry/authentication',
    method: 'post',
    data
  })
}
// 人员列表 - 获取公司列表
function CompanyList (data) {
  return request({
    url: '/company/list',
    method: 'post',
    data
  })
}

// 人员列表  - 离职
// quitStatus 0 zai 1 li
function staffDimission (data) {
  return request({
    url: '/staff/dimission',
    method: 'post',
    data
  })
}
// 待审核详情
function staffAuditDetail (data) {
  return request({
    url: '/audit/detail',
    method: 'post',
    data
  })
}
// 账户权限公司
function companyUserList (data) {
  return request({
    url: '/company/user/list',
    method: 'post',
    data
  })
}

// 首页跳转接口数据
function staffTurnpver (data) {
  return request({
    url: '/staff/turnover',
    method: 'post',
    data
  })
}

// 续签合同
function StaffRenewal (data) {
  return request({
    url: '/staff/renewal',
    method: 'post',
    data
  })
}

// 一线员工导入用户表
function StaffToUserTable (data) {
  return request({
    url: '/staff/import/user',
    method: 'post',
    data
  })
}

// 请假
function StaffLeave (data) {
  return request({
    url: '/staff/leave',
    method: 'post',
    data
  })
}
// 取消请假
function StaffCancelLeave (data) {
  return request({
    url: '/staff/cancelleave',
    method: 'post',
    data
  })
}
// 项目上人员列表
function StaffProjectList (data) {
  return request({
    url: '/staff/list/project',
    method: 'post',
    data
  })
}
// 员工列 - 已审核员工 - 调级申请
function StafLevelapply (data) {
  return request({
    url: '/staff/levelapply',
    method: 'post',
    data
  })
}
// 员工列 - 调级审批
function StafLevelAuditList (data) {
  return request({
    url: '/staff/level/audit/list',
    method: 'post',
    data
  })
}
// 员工列 - 调级审批 - 驳回和通过
// levelStatus 3 调级审批中 2驳回
function StafLevelstatus (data) {
  return request({
    url: '/staff/level/status',
    method: 'post',
    data
  })
}
// 员工列 - 我的审核
function StafLevelMyList (data) {
  return request({
    url: '/staff/level/my/list',
    method: 'post',
    data
  })
}

// 员工列 - 我的审核 - 重新编辑
function StafLevelResubmit (data) {
  return request({
    url: '/staff/level/resubmit',
    method: 'post',
    data
  })
}

// 我发起的审批入职流程
function staffAuditmylist (data) {
  return request({
    url: '/staffAudit/my/list',
    method: 'post',
    data
  })
}

// 入职员工列表
// 传参数q 字段examineStatus=5
// page pageSize
function staffJoinlist (data) {
  return request({
    url: '/join/list',
    method: 'post',
    data
  })
}
// 审批编辑
function staffJoinUpdate (data) {
  return request({
    url: '/staff/join/update',
    method: 'post',
    data
  })
}
// 审核编辑详细信息
function staffDetails1 (data) {
  return request({
    url: '/staff/details1',
    method: 'post',
    data
  })
}
// 审批驳回再次编辑
function staffJoinResubmit (data) {
  return request({
    url: '/staff/join/resubmit',
    method: 'post',
    data
  })
}

// 人事审核信息修改接口
// 传 id, editPassStatus(1是审核通过 2是驳回)
function hrAuditApproved (data) {
  return request({
    url: 'hr/audit/approved',
    method: 'post',
    data
  })
}

// 人事审核信息查看列表
// 人事查看的列表 传page和pageSize
function staffEditList (data) {
  return request({
    url: '/staff/edit/list',
    method: 'post',
    data
  })
}
function staffProbationapply (data) {
  return request({
    url: '/staff/probationapply',
    method: 'post',
    data
  })
}

// 人员列表 - 试用期审批列表
function StafLevelProbationList (data) {
  return request({
    url: '/staff/level/probation/list',
    method: 'post',
    data
  })
}
// 人员列表 - 试用期审批 通过和驳回
function StafProbationstatus (data) {
  return request({
    url: '/staff/probation/status',
    method: 'post',
    data
  })
}

// 人员列表 - 我发起的试用期审批
function StafProbationMyList (data) {
  return request({
    url: '/staff/probation/my/list',
    method: 'post',
    data
  })
}
function StafProbationResubmit (data) {
  return request({
    url: '/staff/probation/resubmit',
    method: 'post',
    data
  })
}
// 员工介绍
function StaffMyAllIntroducer (data) {
  return request({
    url: '/staff/my/all/introducer',
    method: 'post',
    data
  })
}

export {
  StaffList,
  StaffDetails,
  StaffAuditList,
  StaffAuditPasslList,
  entryAuthentication,
  CompanyList,
  StaffUpdate,
  StaffAdd,
  AuditApproved,
  StaffDelete,
  staffDimission,
  staffAuditDetail,
  companyUserList,
  staffTurnpver,
  StaffRenewal,
  StaffLeave,
  StaffToUserTable,
  StaffProjectList,
  StaffCancelLeave,
  StafLevelapply,
  StafLevelAuditList,
  StafLevelstatus,
  StafLevelMyList,
  StafLevelResubmit,
  staffAuditmylist,
  staffJoinlist,
  staffJoinUpdate,
  staffDetails1,
  staffJoinResubmit,
  hrAuditApproved,
  staffEditList,
  staffProbationapply,
  StafLevelProbationList,
  StafProbationstatus,
  StafProbationMyList,
  StafProbationResubmit,
  StaffMyAllIntroducer
}
